import { RandomUtils } from '../utils/random-utils';

export enum QuoteStatus {
  DRAFT = 'Brouillon',
  SENT = 'Envoyé',
  SELECTED = 'Retenu',
  UNSELECTED = 'Non retenu',
  ENGAGED = 'Engagé',
  SAVED = 'Enregistré',
  REJECTED = 'Rejeté',
  REFERENCING_REJECTED = 'Référencement refusé',
  REFERENCING_IN_PROGRESS = 'Référencement en cours',
}

export enum QuoteStatusHistoryEnum {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED',
  ENGAGED = 'ENGAGED',
  SAVED = 'SAVED',
  REFERENCING_IN_PROGRESS = 'REFERENCING_IN_PROGRESS',
  REJECTED = 'REJECTED',
  REFERENCING_REJECTED = 'REFERENCING_REJECTED',
}

export const quoteTypeTranslation = (status: QuoteStatus) => {
  switch (status) {
    case QuoteStatus.DRAFT.toString():
      return 'Brouillon';
    case QuoteStatus.SENT.toString():
      return 'Envoyé';
    case QuoteStatus.SELECTED.toString():
      return 'Retenu';
    case QuoteStatus.UNSELECTED.toString():
      return 'Non retenu';
    case QuoteStatus.ENGAGED.toString():
      return 'Engagé';
    case QuoteStatus.SAVED.toString():
      return 'Enregistré';
    case QuoteStatus.REJECTED.toString():
      return 'Rejeté';
    case QuoteStatus.REFERENCING_REJECTED.toString():
      return 'Référencement refusé';
    case QuoteStatus.REFERENCING_IN_PROGRESS.toString():
      return 'Référencement en cours';
    default:
      return null;
  }
};

export const quoteTypeStatusHistoryTranslation = (status: QuoteStatusHistoryEnum) => {
  switch (status) {
    case QuoteStatusHistoryEnum.DRAFT.toString():
      return 'Brouillon';
    case QuoteStatusHistoryEnum.SENT.toString():
      return 'Envoyé';
    case QuoteStatusHistoryEnum.SELECTED.toString():
      return 'Devis retenu';
    case QuoteStatusHistoryEnum.UNSELECTED.toString():
      return 'Non retenu';
    case QuoteStatusHistoryEnum.ENGAGED.toString():
      return 'Engagé';
    case QuoteStatusHistoryEnum.SAVED.toString():
      return 'Enregistré';
    case QuoteStatusHistoryEnum.REJECTED.toString():
      return 'Rejeté';
    case QuoteStatusHistoryEnum.REFERENCING_REJECTED.toString():
      return 'Référencement refusé';
    case QuoteStatusHistoryEnum.REFERENCING_IN_PROGRESS.toString():
      return 'Référencement en cours';
    default:
      return null;
  }
};

/**
 * Masque l'acteur pour les statuts « Référencement en cours / refusé » et « Rejeté » :
 * ces transitions sont automatiques/systèmes, afficher un auteur serait trompeur.
 */
export const shouldHideActorForStatus = (status: QuoteStatusHistoryEnum): boolean => {
  return (
    status === QuoteStatusHistoryEnum.REJECTED ||
    status === QuoteStatusHistoryEnum.REFERENCING_IN_PROGRESS ||
    status === QuoteStatusHistoryEnum.REFERENCING_REJECTED
  );
};

export const quoteTypeEnumObject = (type: QuoteStatus) => {
  return {
    _id: RandomUtils.generateId(),
    value: type,
    label: quoteTypeTranslation(type),
  };
};
